import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const MaintenanceOverlay = ({ children }) => {
  const [maintenance, setMaintenance] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`${API_URL}/api/maintenance-status`);
        const data = await res.json();
        setMaintenance(data.maintenance);
        setMessage(data.message || 'System upgrade in progress. Please check back in 10 minutes.');
      } catch {
        setMaintenance(false);
      }
    };

    check();
    const interval = setInterval(check, 15000); // Re-check every 15 seconds
    return () => clearInterval(interval);
  }, []);

  // Don't block superadmin pages
  const isSuperAdmin = window.location.pathname.startsWith('/superadmin');
  if (!maintenance || isSuperAdmin) return children;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)' }}>
      <div className="text-center px-8 max-w-lg">
        {/* Animated gear icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <svg className="w-24 h-24 text-amber-400 animate-spin" style={{ animationDuration: '3s' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 bg-amber-400 rounded-full opacity-20 animate-ping" />
            </div>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">
          System Upgrade in Progress
        </h1>
        
        <p className="text-slate-300 text-lg mb-6 leading-relaxed">
          {message}
        </p>

        <div className="flex items-center justify-center gap-2 text-slate-400 text-sm">
          <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse" />
          <span>Auto-checking every 15 seconds</span>
        </div>

        <div className="mt-8 p-4 bg-slate-800/50 rounded-xl border border-slate-700">
          <p className="text-slate-400 text-sm">
            We're making improvements to serve you better.
            <br />This page will automatically refresh when the system is ready.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceOverlay;
